import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getNextMessages } from '../../../actions/messages/getNextMessages';
import { currentOpenChatSelector } from '../../../selectors';
import { ERequestApiStatus } from '../../../types/appState';
import { TOpenedChat } from '../../../types/openedChats';

export const useMessagesScroll = (
  scrollToBottom: (isButtonClickScroll?: boolean) => void,
): { getNextMessagesPage: (scrollTop: number) => void } => {
  const currentChat = useSelector(currentOpenChatSelector);

  const dispatch = useDispatch();

  const { pages, allMessagesLoaded, chatId, status } = currentChat || ({} as TOpenedChat);
  const isLoading = status === ERequestApiStatus.Pending;

  const getNextMessagesPage = React.useCallback(
    (scrollTop: number) => {
      if (!allMessagesLoaded && scrollTop <= 0 && !isLoading) {
        dispatch(getNextMessages());
      }
    },
    [allMessagesLoaded, dispatch, isLoading],
  );

  const lastPageMessagesLength = React.useMemo(() => {
    if (pages && pages.length) {
      const lastPageMessages = pages[pages.length - 1]?.messages;

      return lastPageMessages?.length;
    }

    return 0;
  }, [pages]);

  React.useEffect(() => {
    scrollToBottom();
  }, [chatId, scrollToBottom, lastPageMessagesLength]);

  return { getNextMessagesPage };
};
